/** 退款结果以订单状态为准，返回码 0000 仅表示查询已接收。 */
export function parseHelibaoRefundStatus(response) {
  if (response?.code !== 200) {
    throw new Error(
      response?.content || response?.message || response?.msg || "合利宝退款结果查询失败",
    );
  }
  const result = response.data;
  const detail = result?.data;
  if (!detail || typeof detail !== "object" || Array.isArray(detail)) {
    throw new Error(
      (result?.code && result.code !== "0000" && result.message) || "合利宝退款结果格式异常",
    );
  }
  if (detail.rt8_orderStatus != null && typeof detail.rt8_orderStatus !== "string") {
    throw new Error("合利宝退款状态格式异常");
  }
  const status = (detail.rt8_orderStatus ?? "").trim();
  const reason = String(detail.retReason ?? "").trim()
    || String(detail.rt3_retMsg ?? "").trim()
    || String(result.message ?? "").trim();

  // FAILED 等有效订单状态必须展示，不能被包装层的 9999 当作查询异常丢弃。
  if (!status && (result.code !== "0000" || detail.rt2_retCode !== "0000")) {
    throw new Error(reason || "合利宝退款结果查询失败");
  }
  return { ...detail, rt8_orderStatus: status, retReason: reason };
}
